<template>
  <div class="usedMaterials__nav">
    <swiper :options="swiperOption" ref="mySwiper">
          <router-link
            :to="`/details/${allSlopes.indexOf(filteredSlopes[i])}/`"
            class="slopePage__links-item swiper-slide"
            v-for="(item, i) in filteredSlopes"
            :key="i">
            <div class="content">
              <div class="content__img">
                <component
                  :is="filteredSlopes[i].slopeForm"
                  :navId="allSlopes.indexOf(filteredSlopes[i])"
                  :slopeParams="filteredSlopes[i].slopeParams"
                  :defaultSvgParams="defaultSvgParams"
                  :isNav="true">
                </component>
              </div>
              <div class="content__info">
                <div class="content__info-number">
                  <span v-if="allSlopes.indexOf(filteredSlopes[i]) + 1 <= 9">
                    0</span>{{allSlopes.indexOf(filteredSlopes[i]) + 1}}</div>
                  <!--<span v-if="(i + 1) <= 9">0</span>{{ i + 1 }}-->
                <div class="content__info-count">x{{ filteredSlopes[i].slopeCount }}</div>
              </div>
            </div>
            <div class="overlay"><b>Смотреть расчет</b> {{ filteredSlopes[i].name }}</div>
          </router-link>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
  </div>
</template>


<script>

import Trapezoid from '../figures/Trapezoid.vue';
import Square from '../figures/Square.vue';
import ReverseTrapezoid from '../figures/ReverseTrapezoid.vue';
import CornerLeftTop from '../figures/CornerLeftTop.vue';
import CornerRightTop from '../figures/CornerRightTop.vue';
import CornerLeftBottom from '../figures/CornerLeftBottom.vue';
import CornerRightBottom from '../figures/CornerRightBottom.vue';
import Triangle from '../figures/Triangle.vue';
import DoubleSideTriangleHorizontal from '../figures/DoubleSideTriangleHorizontal.vue';
import DoubleSideTriangleVertical from '../figures/DoubleSideTriangleVertical.vue';
import Rhombus from '../figures/Rhombus.vue';
import RectangularTrapezoidHorizontal from '../figures/RectangularTrapezoidHorizontal.vue';
import RectangularTrapezoidVertical from '../figures/RectangularTrapezoidVertical.vue';
import DoubleSideRectangularTrapezoidVertical from
  '../figures/DoubleSideRectangularTrapezoidVertical.vue';

export default {
  props: {
    id: Number,
    height: Number,
    width: Number,
  },
  data() {
    return {
      count: 0,
      swiperOption: {
        slidesPerView: 7.5,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        breakpoints: {
          575: {
            slidesPerView: 3.5,
          },
          359: {
            slidesPerView: 2.5,
          },
        },
      },
    };
  },
  components: {
    Trapezoid,
    Square,
    ReverseTrapezoid,
    CornerLeftTop,
    CornerRightTop,
    CornerLeftBottom,
    CornerRightBottom,
    Triangle,
    DoubleSideTriangleHorizontal,
    DoubleSideTriangleVertical,
    Rhombus,
    RectangularTrapezoidHorizontal,
    RectangularTrapezoidVertical,
    DoubleSideRectangularTrapezoidVertical,
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    filteredSlopes() {
      return this.allSlopes.filter((slope) => {
        return slope.material === this.id && slope.materialSize.width === this.width
          && slope.materialSize.height === this.height;
      });
    },
  },
};
</script>

<style lang="sass">
.usedMaterials
  &__nav
    +media((padding: (320: rem(15) rem(24) rem(9), 768: rem(31) rem(30) rem(9))))
    .swiper
      &-container
        cursor: pointer
        margin: 0
        padding-bottom: rem(34)
        &:hover
          .swiper
            &-scrollbar
              &-drag
                background: rgba(227, 7, 19, 0.5)
          > .swiper-scrollbar
            background: rgba(0, 0, 0, 0.1)
        .slopePage__links-item, .slide
          border: 1px solid #ECECEC
          box-sizing: border-box
          +media((padding: (320: rem(5), 768: rem(10))))
          &__info
            display: flex
            flex-direction: row
            justify-content: space-between
            align-items: center
            &-number, &-count
              font-style: normal
              font-weight: 500
              font-size: rem(12)
              line-height: 1
              color: #999999
            &-number
              font-weight: 700
        .swiper
          &-scrollbar
            height: rem(6)
            bottom: 0
            &-drag
              border-radius: rem(12)
              background: rgba(227, 7, 19, 0.2)
    .swiper-container-horizontal > .swiper-scrollbar
      background: rgba(0, 0, 0, 0.05)
      height: rem(6)
      width: 100%
      left: 0
</style>
